
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@/components/Header';
import { Toaster } from '@/components/ui/toaster';
import Home from '@/pages/Home';

function App() {
  return (
    <>
      <Helmet>
        <title>TALC Assessoria Contábil - Abertura de Empresas e Certificado Digital em Santo Ângelo</title>
        <meta name="description" content="A melhor assessoria contábil de Santo Ângelo. Especialistas em abertura de empresas, certificado digital, recuperação tributária e gestão empresarial." />
      </Helmet>
      <div className="min-h-screen bg-white">
        <Header />
        <Home />
        <Toaster />
      </div>
    </>
  );
}

export default App;
